<template>
  <p class="mt-2 text-left text-sm leading-tight text-wt-red-d">
    <slot />
  </p>
</template>
